<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div class="hasTagsView main-container">
      <div class="fixed-header">
        <navbar
          @showDialog="showDialog"
          @showWxDialog="showWxDialog"
          @showUnWxDialog="showUnWxDialog"
          ref="navbar"
        />
      </div>
      <app-main />
    </div>
    <ModifyPassword ref="modifyPassword" :is-active="dialogShow" @closeDialog="dialogShow = false" />
    <BindWechat ref="bindWechat" />
  </div>
</template>

<script>
import {
  AppMain,
  Navbar,
  Sidebar,
  ModifyPassword,
  BindWechat,
} from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState, mapGetters } from "vuex";
import { unBindWx, queryWxBind } from "@/api/login";
export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    ModifyPassword,
    BindWechat,
  },
  data() {
    return {
      dialogShow: false,
      inRequest:false
    };
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
    }),
    ...mapGetters(["bindWxModelShow"]),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      };
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    showDialog() {
      this.dialogShow = true;
      this.$refs.modifyPassword.initForm();
    },
    closeDialog() {
      this.dialogShow = false;
    },
    showWxDialog() {
      // 演示模式：完全禁用微信绑定功能
      return;
    },
    // 微信绑定结果查询
    getWxBindRes() {
      // 演示模式：完全禁用微信绑定功能
      return;
    },
    showUnWxDialog() {
      this.$confirm(this.$t("wechat.message"), this.$t("generalData.prompt"), {
        confirmButtonText: this.$t("btns.confirm"),
        cancelButtonText: this.$t("btns.cancel"),
        type: "warning",
      })
        .then(() => {
          unBindWx().then((res) => {
          this.$store.commit('SET_WX_HASBIND',false)
            this.$message({
              type: "success",
              message: this.$t("wechat.unBindSuccess"),
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  background: #f5f8fd;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 220px;
  width: calc(100% - 220px);
  z-index: 100;
  transition: width 0.28s;
  background-color: $background;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

.main-container {
  padding-top: 78px;
  background: #f5f8fd;
  min-height: 100vh;
  box-sizing: border-box;
}
</style>
